
import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft, Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useBuyer } from "@/contexts/BuyerContext";
import { useAuth } from "@/contexts/AuthContext";
import { PropertyShareButtons } from "@/components/common/SocialShareButtons";

interface PropertyDetailHeaderProps {
  propertyId: string;
  propertyAddress: string;
  sellerId?: string;
}

export const PropertyDetailHeader = ({
  propertyId,
  propertyAddress,
  sellerId
}: PropertyDetailHeaderProps) => {
  const { isBuyer } = useBuyer();
  const { user } = useAuth();
  const navigate = useNavigate();
  
  // Check if current user is the property owner
  const isOwner = !isBuyer && user?.id === sellerId;

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(isBuyer ? "/buyer/search" : "/seller/properties/active");
    }
  };

  const editLink = isBuyer ? undefined : `/seller/properties/${propertyId}/edit`;

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <div className="flex items-center w-full sm:w-auto">
        <button onClick={handleBack} className="text-godyspo-blue mr-2">
          <ChevronLeft className="h-5 w-5" />
        </button>
        <h1 className="text-2xl font-bold tracking-tight">{propertyAddress}</h1>
      </div>
      
      {/* Share button for any viewer, Edit button for owner only */}
      {sellerId && (
        <div className="flex items-center gap-2">
          <PropertyShareButtons
            propertyId={propertyId}
            sellerId={sellerId}
            propertyAddress={propertyAddress}
          />
          {isOwner && editLink && (
            <Link to={editLink}>
              <Button className="bg-godyspo-blue hover:bg-godyspo-blue/90">
                <Pencil className="h-4 w-4 mr-2" />
                Edit Property
              </Button>
            </Link>
          )}
        </div>
      )}
    </div>
  );
};
